import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { isProd } from "@/config";
import Drip from "drip";
import Url from 'drip/utils/url';
export function groupBuyUrlReplace(jumpUrl) {
  // 在点评吃喝玩乐 h5 渠道，把团购url 域名替换为点评域名
  if (Drip.constant.sellChannel !== 3) return jumpUrl;
  if (!jumpUrl) return '';
  var url = Url.stringify(jumpUrl, {
    from: 'showdianpingh5'
  });
  if (isProd) {
    return url.replace('https://m.maoyan.com', 'https://h5.dianping.com');
  } else {
    return url.replace('https://canary.movie.test.maoyan.com', 'https://h5.51ping.com');
  }
}